import { graphql, useStaticQuery } from 'gatsby';

import { ILibraryMeetingPlaceDictionary } from '../queries/fragments/libraryMeetingPlaceDictionary';
import { ILibraryMeetingPlaceConstantsDictionary } from '../queries/fragments/libraryMeetingPlaceDictionaryConstants';
export const useGetLibraryConstantsDictionary = (
  locale: string,
): ILibraryMeetingPlaceDictionary | undefined => {
  const data: {
    allContentfulLibraryConstantsDictionary: {
      nodes: ILibraryMeetingPlaceConstantsDictionary[];
    };
  } = useStaticQuery(graphql`
    query {
      allContentfulLibraryConstantsDictionary {
        nodes {
          ...LibraryMeetingPlaceConstantsDictionary
        }
      }
    }
  `);
  return data?.allContentfulLibraryConstantsDictionary?.nodes
    .filter((dict) => dict?.node_locale === locale)
    .reduce((acc: any, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {});
};
